import { openDB } from 'idb';
import store from '@/store/index';
console.log('Se esta ejecutando el archivo db.js');

const lnVersionDB = 4;
const lcNombreDB = 'lecturas-db';


// Cambiar esto cuando haya una actualización en la base de datos
const loDataBase = openDB(lcNombreDB, lnVersionDB, {

  upgrade(db, oldVersion, newVersion, transaction) {
    console.warn('SE ESTA EJECUTANDO UPGRADE DE LA BASE DE DATOS, HAY UNA NUEVA VERSION');
   
    store.dispatch('triggerActualizarApp', {
      estado: true,
      mensaje: 'Base de datos actualizada, Version ' + newVersion,
      actualizar: true,
      tipo: 1,
  });
   
    // Eliminar todas las tablas (object stores) antes de recrearlas
    // Array.from(db.objectStoreNames).forEach((storeName) => db.deleteObjectStore(storeName));
    // localStorage.clear();
    // sessionStorage.clear();



    //GENERACIONFACTURA
    db.createObjectStore('GENERACIONFACTURA', { keyPath: 'GeneracionFactura' });
    const GeneracionLecturaStore = db.createObjectStore('GENERACIONLECTURA', { keyPath: 'Cliente' });
    GeneracionLecturaStore.createIndex('GeneracionFactura', 'GeneracionFactura');
    GeneracionLecturaStore.createIndex('ZonaRuta', 'ZonaRuta', { unique: false });

    //base de datos para MEDIDORANORMALIDAD
    db.createObjectStore('MEDIDORANORMALIDAD', { keyPath: 'MedidorAnormalidad' });

    db.createObjectStore('LOGMOVIL', { keyPath: 'id', autoIncrement: true });

    const LecturaNoSubida = db.createObjectStore('lecturas_no_subidas', { keyPath: ['tnCliente', 'tnGeneracionFactura'] });
    LecturaNoSubida.createIndex('tnEstado', 'tnEstado'); 
    // LecturaNoSubida.createIndex('IndexCliGenFac', ['tnCliente', 'tnGeneracionFactura'], { unique: false });


    db.createObjectStore('REGLALECTURACIONDETALLE', { keyPath: 'ReglaLecturacion' });
    db.createObjectStore('CATEGORIA', { keyPath: 'Categoria' });
    const categoriaConsumoStore = db.createObjectStore('CATEGORIACONSUMO', { keyPath: 'id', autoIncrement: true });
    categoriaConsumoStore.createIndex('Categoria', 'Categoria', { unique: false });

    const categoriaDetalleStore = db.createObjectStore('CATEGORIADETALLE', { keyPath: 'id', autoIncrement: true });
    categoriaDetalleStore.createIndex('Categoria', 'Categoria', { unique: false });

    db.createObjectStore('MEDIACONSUMO', { keyPath: 'MediaConsumo' });
    db.createObjectStore('PARAMETROLECTURA', { keyPath: 'ParametroLectura' });
    db.createObjectStore('PARAMETROGENERALES', { keyPath: 'Empresa' });
    const clienteMedidorStore = db.createObjectStore('CLIENTEMEDIDOR', { keyPath: 'ClienteMedidor' });
    clienteMedidorStore.createIndex('Cliente', 'Cliente');
    db.createObjectStore('GENERACIONLECTURAMOVIL', { keyPath: 'Cliente', });

    const ModificacionStore = db.createObjectStore('MODIFICACIONGENERACIONLECTURA ', { keyPath: 'id', autoIncrement: true });
    ModificacionStore.createIndex('GeneracionFactura', 'GeneracionFactura', { unique: false });
    ModificacionStore.createIndex('Cliente', 'Cliente', { unique: false });


    db.createObjectStore('FECHA', { keyPath: 'Fecha' });
    const IndiceStore = db.createObjectStore('INDICEPRECIOCONSUMIDOR', { keyPath: 'IndicePrecioConsumidor' });
    IndiceStore.createIndex('Cobro', 'Cobro', { unique: false });
    const facturaDetalleStore = db.createObjectStore('FACTURADETALLE', { keyPath: 'id', autoIncrement: true });
    facturaDetalleStore.createIndex('Factura', 'Factura', { unique: false });
    const facturaStore = db.createObjectStore('FACTURA', { keyPath: 'Factura' });
    facturaStore.createIndex('GeneracionFactura', 'GeneracionFactura', { unique: false });
    facturaStore.createIndex('Cliente', 'Cliente', { unique: false });


    db.createObjectStore('PARAQR', { keyPath: 'ParaQR' });
    const historicoStore = db.createObjectStore('HISTORICOFACTURA', { keyPath: 'Factura' });
    historicoStore.createIndex('Cliente', 'Cliente', { unique: false });
    const mensajeStore = db.createObjectStore('MENSAJE', { keyPath: 'Mensaje' });
    mensajeStore.createIndex('Cobro', 'Cobro');

    const imagenesStore = db.createObjectStore('GENERACIONLECTURAFOTO', { keyPath: 'id', autoIncrement: true });
    imagenesStore.createIndex('Cliente', 'Cliente', { unique: false });
    imagenesStore.createIndex('GeneracionFactura', 'GeneracionFactura', { unique: false });

  },
});

export const getDataBase = () => loDataBase;
